/***
 * Created on 2023/8/2
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import { createRoot } from 'react-dom/client';
import AccMainApp from "../component/acc_main_app";

let root = null;

export function bootstrap(props) {
  return Promise.resolve();
}

export function mount(props) {
  return Promise.resolve().then(() => {
    const domElement = document.querySelector('.acc-mf-app');
    root = createRoot(domElement);
    root.render(<AccMainApp {...props} />);
  });
}

export function unmount(props) {
  return Promise.resolve().then(() => {
    if (root) {
      root.unmount();
      root = null;
    }
  });
}

export default { bootstrap, mount, unmount };
